import EditIcon from '@mui/icons-material/Edit';
import { GridActionsCellItem } from '@mui/x-data-grid';

const FAMILY_COLUMNS = handleEdit => [
  {
    field: 'familyNum',
    headerName: 'Número',
    maxWidth: 100,
    type: 'number',
  },
  {
    field: 'familyName',
    headerName: 'Nombre',
    flex: 4,
    minWidth: 200,
  },
  {
    field: 'chains',
    headerName: 'Cadenas',
    flex: 1,
    minWidth: 200,
    align: 'center',
    headerAlign: 'center',
    valueGetter: params =>
      params.row.chains.map(chain => chain.chainName).join(', '),
  },
  {
    field: 'isActive',
    headerName: 'Activo',
    type: 'boolean',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Acciones',
    flex: 1,
    minWidth: 100,
    align: 'center',
    getActions: params => [
      <GridActionsCellItem
        icon={<EditIcon />}
        label="Editar"
        onClick={() => handleEdit(params)}
      />,
    ],
  },
];

export default FAMILY_COLUMNS;
